import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import delete_img from '../assets/icons/delete.svg';
import FormControlError from "../components/Controls/FormControlError";
import { getAuthToken } from "../helpers/authHelper";
import useCallApiAndLoad from "../hooks/useCallApiAndLoad";
import { AppStore } from "../redux/store";
import { uploadAvatarEndpoint } from '../services/publicService';

interface Props {
    onAction: () => void;
    realm: string;
}

const UploadAvatar = (props: Props) => {

    const { onAction, realm } = props
    const [myFiles, setMyFiles] = useState<Array<any>>([])
    const [imageAccepted, setImageAccepted] = useState<any>()
    const { isLoading, callEndpoint } = useCallApiAndLoad()
    const user = useSelector((store: AppStore) => store.auth)
    const [error, setError] = useState('')
    const navigate = useNavigate()

    const onDrop = useCallback((acceptedFiles: any) => {
        setError('')
        setImageAccepted(acceptedFiles)
        setMyFiles([...acceptedFiles.map((file: any) => Object.assign(file, {
            preview: URL.createObjectURL(file)
        }))])
    }, [myFiles, imageAccepted])

    // Dropzone config
    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
        accept: {
            'image/*': []
        },
        onDrop,
    })

    const removeFile = (file: any) => {
        const newFiles = [...myFiles]
        newFiles.splice(newFiles.indexOf(file), 1)
        setMyFiles(newFiles)
    }

    const handleUpload = async() => {
        setError('')
        if(!imageAccepted || !imageAccepted.length){
            setError('Debés seleccionar una imágen para subir')
        }
        let formData = new FormData()
        formData.append('avatar', imageAccepted[0])
        const token = getAuthToken(user)
        const {status, data} = await callEndpoint(uploadAvatarEndpoint(formData, token, realm))
        if(status === 200){
            navigate(0) //make a reload
        } else {
            setError('Lo sentimos, por el momento no es posible completar la acción')
        }
    }

    const files = myFiles.map(file => (
        <div className='flex justify-between items-center my-2 border-gray500 border rounded-md p-2' key={file.path}>
            <p className='text-sm text-gray-500'>{file.path} - {file.size} bytes{" "}</p>
            <button onClick={() => removeFile(file)}>
                <img className='' src={delete_img} alt="" />
            </button>
        </div>
    ))

    const thumbs = myFiles.map(file => (
        <div key={file.name}>
            <img className='w-40 h-40 object-cover' src={file.preview} onLoad={() => { URL.revokeObjectURL(file.preview) }} alt="avatar" />
        </div>
    ));

    return (
        <div className="w-full text-center bg-white ">
            <div className="text-graySoft pt-0 pb-4">
                <div {...getRootProps({ className: " bg-[#E7F8EF] rounded-xl border-2 border-dotted border-[#0E7C3A] flex flex-col py-8 w-full justify-center items-center" })}>
                    <input {...getInputProps()} />
                    <p className=' text-[#212121] font-semibold text-base'>Arrastra tu foto o Selecciona</p>
                    <span className='text-[#757575] text-sm'>Formatos soportados: JPEG y PNG, máximo de 1MB por archivo.</span>
                </div>
                <div className='mt-2'>
                    <div className='w-full mt-4'>{files}</div>
                    <div className='w-full flex flex-wrap mt-4 gap-4'>{thumbs}</div>
                </div>
                <FormControlError message={error} />
            </div>
            <div className="bg-white border-t border-[#e0e0e0] w-full">
                <div className="w-full flex justify-between pt-4 items-center">
                    <button>
                        <div
                            onClick={onAction}
                            className="text-[#212121] text-sm font-medium rounded-lg border border-[#212121] py-1 px-4">
                            Cancelar
                        </div>
                    </button>
                    <button
                        disabled={isLoading}
                        onClick={handleUpload}
                        className="text-white text-sm font-medium rounded-lg border py-1 px-4 bg-primary">
                        <span className="mx-auto">Actualizar mi foto</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UploadAvatar
